<template>
    <v-dialog v-model="dialog" max-width="450">
    <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="#F15A24"
          class="mr-3"
          text
          v-bind="attrs"
          v-on="on"
        >
        <v-icon>{{ icon }}</v-icon>
          {{botao}}
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5">
          {{titulo}}
        </v-card-title>

        <v-card-text>
            {{ texto }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="#F15A24"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="#F15A24"
            dark
            @click="confirmado"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  name: "DialogConfirm",
  props: { texto: String, titulo: String, icon: String, botao: String, confirmado: Function },
  data() {
    return {
      dialog:false
    };
  },
}
</script>